import React, {Component, PropTypes as T} from 'react';
import './button.less';
import classNames from 'classnames';
import './splitbutton.less';

const types = ["primary", "success", "warning", "danger", "bordered", "default"];

export default class Button extends Component {
	static defaultProps = {
        type : "primary",
        disabled: false,
        splitLeft: false,
        splitRight: false,
        onClick: () => {},
        onMouseOver: () => {},
        onMouseOut: () => {}
    };

    static propTypes = {
        type: T.oneOf(types).isRequired,
        block: T.bool,
        splitLeft: T.bool,
        splitRight: T.bool
	};

    handleOnClick(event) {
        if (!this.props.disabled) {
            this.props.onClick(event);
        }
    }

    render() {
    	var { active, children, type, disabled, block, style = {}, splitLeft, splitRight, onMouseOver, onMouseOut, tabIndex, showTooltipFor } = this.props;

        var tooltipProps = showTooltipFor ? {
            'data-tip': true,
            'data-for': showTooltipFor
        } : {};

        let conditionalClassNames = classNames({
            disabled, 
            block,
            active,
            'split-left': splitLeft,
            'split-right': splitRight
        });

        var buttonClasses = `button ${type} ${conditionalClassNames} ${this.props.className}`;

        return (
            <button 
                {...tooltipProps}
                tabIndex={tabIndex}
                onMouseOver={onMouseOver}
                onMouseOut={onMouseOut}
                onClick={this.handleOnClick.bind(this)} 
                style={style}
                type="submit" 
                className={buttonClasses}>
                {children}
            </button>
        );
    }
}



// WEBPACK FOOTER //
// ./app/b3/buttons/Button.js